import React from 'react';

export default function HorizontalMovieListItemSkeleton(): React.JSX.Element {
    return (
        <div className="relative flex-none h-[195px] aspect-[2/3] rounded-4 bg-[var(--surface-color)] animate-pulse-skeleton" />
    );
}
